<template>
  <div class="job-business-area-selector">
    <h4
      v-if="name && !settings.noHeader"
      :class="{ 'text-danger': invalidFeedback }"
    >
      <b>{{name}}{{required ? '*' : ''}}</b>
    </h4>
    <p
      v-if="description && !settings.noHeader"
      :class="{ 'text-danger': invalidFeedback, 'text-muted': !invalidFeedback }"
    >
      {{description}}
    </p>
    <b-form-group :label="settings.noHeader ? name : (settings.noTitle ? null : (settings.noTitle || $root.isCXR ? null : 'Business Area'))">
      <multiselect
        :value="value"
        @input="$emit('input', $event)"
        :options="options && options.length ? options : defaultOptions"
        :multiple="multiple"
        :group-select="false"
        placeholder="Select a business area"
        class="multiselect-rlnx"
      >
        <template v-slot:noResult>Business area not found, try something similar</template>
      </multiselect>
    </b-form-group>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'JobBusinessAreaSelector',
  components: {
    Multiselect
  },
  props: {
    name: {
      type: String,
    },
    description: {
      type: String,
    },
    value: {
      default: () => null,
    },
    options: {
      type: Array,
      default: () => null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
    invalidFeedback: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    fatalErr: null,
    err: null,
    defaultOptions: [
      'Marketing',
      'Engineering',
      'Customer Success',
      'Sales',
      'Human Resources',
      'Finance',
      'Management',
      'Support',
    ],
    department: null,
  }),
};
</script>

<style lang="scss">
.job-business-area-selector {
  .multiselect-rlnx {
    .multiselect__tags {
      height: auto;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/profile/JobBusinessAreaSelector.vue